
// frontend/geopolitikia/src/hooks/useNewspaper.js
import { useState, useEffect, useCallback } from 'react';
import axios from '../components/AxiosInstance';

const useNewspaper = (setLoading, year, isMulti = false) => {
  const [previousArticles, setPreviousArticles] = useState([]);
  const [showNewspaperPopup, setShowNewspaperPopup] = useState(false);
  const [selectedYear, setSelectedYear] = useState(null);
  const [showArchivePopup, setShowArchivePopup] = useState(false);

  const fetchPreviousArticles = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get("/articles");
      setPreviousArticles(response.data);

      if (response.data && response.data.length > 0) {
        setShowNewspaperPopup(true);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des articles :", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  useEffect(() => {
    if (!isMulti) {
      fetchPreviousArticles();
    }
  }, [fetchPreviousArticles, isMulti]);

  const uniqueYears = [...new Set(previousArticles.map(article => article.year))];
  const sortedYears = uniqueYears.sort((a, b) => b - a);

  const popin = useCallback(() => {
    setShowArchivePopup(true);
  }, []);

  return { previousArticles, setPreviousArticles, showNewspaperPopup, setShowNewspaperPopup, selectedYear, setSelectedYear, showArchivePopup, setShowArchivePopup, sortedYears, popin };
};

export default useNewspaper;
